

import React, { useRef, useState,useEffect } from 'react';

import "./style.css"
import { Icon_arrow_cart } from '../../../../../../assets/icons';

const ImageSilder=(props:any)=>{

    const imageContainerRef = useRef(null);
    const [scrollPosition, setScrollPosition] = useState(0);
  
    const scroll = (direction:any) => {
      const container:any = imageContainerRef.current;
      if (container) {
        const scrollDistance = container.clientWidth / 2 * direction;
        const newPosition = container.scrollLeft + scrollDistance;
        setScrollPosition(newPosition);
      }
    };
  
    useEffect(() => {
      const container:any = imageContainerRef.current;
      if (container) {
        container.scrollTo({ left: scrollPosition, behavior: 'smooth' });
      }
    }, [scrollPosition]);
  
    return (
      <div className="main">
        
        <div className="wrapper flex  justify-center">
            <div className='flex items-center justify-center pr-2'>
          {/* <a className="prev cursor-pointer" onClick={() => scroll(-1)}>
            &#10094;
          </a> */}
          <img src={Icon_arrow_cart} style={{height:18, width:18,marginTop:18}} className="cursor-pointer" onClick={() => scroll(-1)}></img>
          </div>
          <div className="image-container" ref={imageContainerRef}>
            {props.images.map((image:any, index:any) => (
              <div key={index} onClick={() => props.onChangeMainImage(image)} className="image">
                <img src={image} />
              </div>
            ))}
          </div>
          <div className='flex items-center pl-2'>
          {/* <a className="next cursor-pointer" onClick={() => scroll(1)}>
            &#10095;
          </a> */}
           <img src={Icon_arrow_cart} style={{height:18, width:18,marginTop:18}} className="rotate-180 cursor-pointer" onClick={() => scroll(1)}></img>
          </div>
        </div>
      </div>
    );

}

export default ImageSilder;